<template>
    <ValidationErrors :show="showErrors"/>
    <Head :title="quote.name + ' - ' + project.title"/>
    <Audit v-if="openModal" @close="openModal = false" :open="openModal" :activity_logs="quote.activity_logs" />
    <div class="w-full mb-6">
        <ValidationErrors/>
        <ProjectHeader :project="project" :quote="quote" :show_currency_code="show_currency_code">
            <template v-slot:actions>
                <Link :href="route('frontend.project.quote.index', project.id)"
                      class="inline-flex items-center h-10 px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs uppercase text-black bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200">
                    <ArrowCircleLeftIcon class="-ml-0.5 mr-2 h-4 w-4"></ArrowCircleLeftIcon>
                    Back to Quotes
                </Link>
            </template>
        </ProjectHeader>
        <div class="space-y-6 lg:col-span-9">
            <section aria-labelledby="payment-details-heading">
                <form @submit.prevent="submit">
                    <div class="shadow  sm:overflow-hidden">
                        <div class="bg-white px-4 p-6 space-y-6">
                            <div class="pb-5 border-b border-gray-200 flex justify-between items-center">
                                <div class="flex grid grid-cols-2 items-center">
                                    <div>
                                        <div class="flex items-end">
                                            <h3
                                                class="flex text-lg leading-6 font-bold text-gray-900 mr-3">
                                                {{ quote.name }}
                                            </h3>
                                            <span class="text-sm font-medium">{{ quote.client.name }}</span>

                                            <div class="ml-3 flex-col" v-if="accepted === false">
                                                <span v-if="quote.status === 'Request'"
                                                      class="w-auto inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-gray-500 text-white"> {{
                                                        quote.status
                                                    }} </span>
                                                <span v-if="quote.status === 'Confirmed'"
                                                      class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-gray-100 text-green-800"> {{
                                                        quote.status
                                                    }} </span>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="flex items-end">
                                    <button type="button" @click="openModal = true"
                                        class="inline-flex mr-3 items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 rounded-md text-white bg-amaze-coral focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black">
                                        Show Changelog
                                    </button>
                                    <Button @click="emitter.emit('createFolderSlideout', {folder_id: null})"
                                            class="shadow-md inline-flex mr-3 items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 rounded-md text-white bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black">
                                        <folder-add-icon class="-ml-0.5 mr-2 h-4 w-4"></folder-add-icon>
                                        Add Folder
                                    </Button>
                                    <Button @click="emitter.emit('createServiceSlideout', null)"

                                            :class="{'mr-3': quote.status !== 'Confirmed' && accepted === false}"
                                            class="shadow-md inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 rounded-md text-white bg-amaze-coral focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                        <svg class="-ml-0.5 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none"
                                             viewBox="0 0 24 24"
                                             stroke="currentColor" aria-hidden="true">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                  d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                        </svg>
                                        Add Service Line
                                    </Button>
                                    <Button @click="cancelQuote(quote.id)"
                                            v-if="quote.status !== 'Confirmed' && quote.status !== 'Cancelled' && accepted === false"
                                            :class="{'mr-3': quote.status !== 'Confirmed' && quote.status !== 'Cancelled' && accepted === false}"
                                            class="shadow-md inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 rounded-md text-white bg-sky-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500">
                                        <trashIcon class="-ml-0.5 mr-2 h-4 w-4"></trashIcon>
                                        Cancel
                                    </Button>
                                    <Button @click="confirmQuote(quote.id)"
                                            v-if="quote.status !== 'Confirmed' && quote.status !== 'Cancelled' && accepted === false"
                                            :disabled="!!quote.check_can_confirm"
                                            :title="quote.check_can_confirm || 'Confirm quote'"
                                            class="shadow-md inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 rounded-md text-white bg-green-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:opacity-50 disabled:cursor-not-allowed">
                                        <check-circle-icon class="-ml-0.5 mr-2 h-4 w-4"></check-circle-icon>
                                        Confirm
                                    </Button>
                                </div>
                            </div>
                            <QuoteTabs/>
                            <div class="-my-2 !mt-0 overflow-x-auto sm:-mx-6 lg:-mx-8 min-w-full">
                                <div class="align-middle inline-block min-w-full sm:px-6 lg:px-8">
                                    <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                        <div
                                            class="bg-white shadow overflow-auto relative sm:rounded-md min-w-full table-example" style="max-height:600px;">
                                            <div class="flex w-full grid grid-cols-24 bg-gray-100">
                                                <div
                                                    class="px-1 flex items-center justify-center text-center text-xs border-r font-medium text-gray-500 uppercase">
                                                    <button v-if="batchItems.length > 0"
                                                            @click="emitter.emit('openBatchEditorSlideout')" title="Batch Update"
                                                            class="px-1 py-1 relative inline-flex items-center border border-transparent shadow-sm rounded-md text-white bg-amaze-coral hover:bg-amaze-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500">
                                                        <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg"
                                                             fill="none" viewBox="0 0 24 24" stroke-width="2"
                                                             stroke="currentColor" aria-hidden="true">
                                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                                  d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path>
                                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                                                        </svg>
                                                    </button>
                                                </div>
                                                <div
                                                    class="flex flex-grow col-span-4 px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Item
                                                </div>
                                                <div
                                                    class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Start
                                                </div>
                                                <div
                                                    class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    End
                                                </div>
                                                <div
                                                    class="px-1 py-3 col-span-2 text-left text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Supplier
                                                </div>
                                                <div
                                                    class="px-1 py-3 col-span-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Description
                                                </div>
                                                <div
                                                    class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Sell Price
                                                </div>
                                                <div
                                                    class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Sell Unit
                                                </div>
                                                <div
                                                    class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Sell No
                                                </div>
                                                <div
                                                    class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Sell VAT
                                                </div>
                                                <div
                                                    class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Sell Total
                                                </div>
                                                <div
                                                    class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Buy Price
                                                </div>
                                                <div
                                                    class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Buy Unit
                                                </div>
                                                <div
                                                    class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Buy No
                                                </div>
                                                <div
                                                    class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Buy VAT
                                                </div>
                                                <div
                                                    class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Buy Total
                                                </div>
                                                <div
                                                    class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Profit
                                                </div>
                                                <div
                                                    class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider">
                                                    Profit %
                                                </div>
                                            </div>
                                            <NestedDraggable type="folder" :project="project" :class="'dragArea'" :items="items.folders"
                                                             :quote="quote" :show_currency_code="show_currency_code" />
                                            <NestedDraggable type="service" :project="project" :items="items.services" :quote="quote" :show_currency_code="show_currency_code"/>
                                            <div
                                                class="bg-white shadow overflow-hidden min-w-full table-example border-t border-t-2">
                                                <div class="flex grid grid-cols-24 bg-gray-200 border-b border-gray-300">
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                    </div>
                                                    <div
                                                        class="col-span-4 px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                        Totals
                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                    </div>
                                                    <div
                                                        class="col-span-2 px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                    </div>
                                                    <div
                                                        class="col-span-3 px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                        {{
                                                            formatCurrency(quote.subtotals.gross_sell_total, quote.buy_currency.code)
                                                        }}
                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                        {{
                                                            formatCurrency(quote.subtotals.gross_buy_total, project.bank_account.currency.code)
                                                        }}
                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider">

                                                    </div>
                                                </div>
                                                <div class="flex grid grid-cols-24 bg-gray-200 border-b border-gray-300">
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                    </div>
                                                    <div
                                                        class="col-span-4 px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                        Commission
                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                    </div>
                                                    <div
                                                        class="col-span-2 px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                    </div>
                                                    <div
                                                        class="col-span-3 px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                        {{
                                                            '-' + formatCurrency(quote.subtotals.commission, project.bank_account.currency.code)
                                                        }}
                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider">

                                                    </div>
                                                </div>
                                                <div class="flex grid grid-cols-24 bg-gray-200 border-b border-gray-300">
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                    </div>
                                                    <div
                                                        class="col-span-4 px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                        Expenses
                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                    </div>
                                                    <div
                                                        class="col-span-2 px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                    </div>
                                                    <div
                                                        class="col-span-3 px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                        {{
                                                            formatCurrency(quote.subtotals.expenses_total, project.bank_account.currency.code)
                                                        }}
                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider">

                                                    </div>
                                                </div>
                                                <div class="flex grid grid-cols-24 bg-gray-200">
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                    </div>
                                                    <div
                                                        class="col-span-4 px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                        Overall Total
                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                    </div>
                                                    <div
                                                        class="col-span-2 px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                    </div>
                                                    <div
                                                        class="col-span-3 px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                        {{
                                                            formatCurrency(quote.subtotals.overall_sell_total, project.bank_account.currency.code)
                                                        }}
                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">

                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                        {{
                                                            formatCurrency(quote.subtotals.overall_buy_total, project.bank_account.currency.code)
                                                        }}
                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                        {{
                                                            formatCurrency(quote.subtotals.overall_profit, project.bank_account.currency.code)
                                                        }}
                                                    </div>
                                                    <div
                                                        class="px-1 py-3 text-center text-xs text-gray-500 uppercase tracking-wider">
                                                        {{
                                                            number_format(parseFloat(quote.subtotals.overall_profit_percentage).toFixed(2))
                                                        }}%
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex gap-3 text-xs">
                                <span class="font-bold">Quote Options:</span>
                                <span @click="emitter.emit('createFolderSlideout', {folder_id: null})"
                                      class="flex hover:underline cursor-pointer"><FolderAddIcon
                                    class="w-4 h-4 mr-2"/> Add New Folder</span>
                                <span @click="emitter.emit('createServiceSlideout', null)"
                                      class="flex hover:underline cursor-pointer"><DocumentAddIcon
                                    class="w-4 h-4 mr-2"/> Add New Service</span>
                                <span @click="editQuote(quote)" class="flex hover:underline cursor-pointer"><PencilIcon
                                    class="w-4 h-4 mr-2 text-yellow-500"/> Rename Offer</span>
                                <a :href="route('frontend.project.quote.export.internal', [project.id, quote.id])"
                                   class="flex hover:underline cursor-pointer">
                                    <DocumentDownloadIcon
                                        class="w-4 h-4 mr-2 text-light-pitch-purple"/>
                                    Export Offer - Internal</a>
                                <a :href="route('frontend.project.quote.export.external', [project.id, quote.id])"
                                   class="flex hover:underline cursor-pointer">
                                    <DocumentDownloadIcon
                                        class="w-4 h-4 mr-2 text-green-500"/>
                                    Export Offer - Client Version</a>
                            </div>
                        </div>
                    </div>
                </form>
            </section>
        </div>
        <CreateFolder :quote="quote" :project="project"/>
        <CreateQuote ref="create_quote" :project="project"/>
        <CreateService :quote="quote" :project="project"/>
        <BatchEditor :quote="quote" :project="project" :items="batchItems"/>
        <ImportAmazeQuote :quote="quote" :project="project"/>
        <ConfirmQuote :quote="quote" :project="project"/>
    </div>
</template>


<script>
import Authenticated from "@/Layouts/Authenticated.vue";
import {Link, Head, usePage, useForm} from "@inertiajs/vue3";
import {
    ClipboardCopyIcon,
    PlusSmIcon,
    UsersIcon,
    InformationCircleIcon,
    ChevronDownIcon,
    CogIcon,
    PencilIcon,
    CheckCircleIcon,
    ArrowCircleLeftIcon,
    FolderAddIcon,
    FolderIcon,
    DocumentAddIcon,
    DocumentDownloadIcon,
    UploadIcon,
    TrashIcon
} from "@heroicons/vue/outline"
import ValidationErrors from "@/Components/ValidationErrors";
import ProjectHeader from "@/Components/ProjectHeader";
import {Popover, PopoverButton, PopoverGroup} from "@headlessui/vue";
import QuoteTabs from "@/Components/QuoteTabs";
import CreateFolder from "@/Components/SlideOuts/CreateFolder";
import CreateQuote from "@/Components/SlideOuts/CreateQuote";
import CreateService from "@/Components/SlideOuts/CreateService";
import BatchEditor from "@/Components/SlideOuts/BatchEditor.vue";
import Button from "@/Components/Button.vue";
import pickBy from "lodash/pickBy";
import { reactive, ref } from "vue";
import NestedDraggable from "@/Components/NestedDraggable";
import {emitter} from "@/eventHub";
import ImportAmazeQuote from "@/Components/SlideOuts/ImportAmazeQuote";
import ConfirmQuote from "@/Components/SlideOuts/ConfirmQuote.vue";
import Audit from "@/Components/Modal/Audit.vue";

export default {
    layout: Authenticated,
    components: {
        ImportAmazeQuote,
        Button,
        QuoteTabs,
        ProjectHeader,
        ValidationErrors,
        Link,
        Head,
        PlusSmIcon,
        UsersIcon,
        InformationCircleIcon,
        Popover,
        PopoverButton,
        ChevronDownIcon,
        PopoverGroup,
        CogIcon,
        PencilIcon,
        ClipboardCopyIcon,
        CheckCircleIcon,
        ArrowCircleLeftIcon,
        FolderAddIcon,
        CreateFolder,
        FolderIcon,
        NestedDraggable,
        DocumentAddIcon,
        DocumentDownloadIcon,
        CreateQuote,
        CreateService,
        UploadIcon,
        BatchEditor,
        ConfirmQuote,
        TrashIcon,
        Audit
    },
    props: {
        project: Object,
        quote: Object,
        errors: Object,
        items: Object,
        accepted: Boolean,
        show_currency_code: Boolean
    },
    setup() {
        const openModal = ref(false);

        return {openModal};
    },
    data() {
        return {
            showErrors: false,
            emitter: emitter,
            batchItems: ref([])
        }
    },
    mounted() {
        emitter.on('deleteFolder', (folder_id) => {
            this.deleteFolder(folder_id);
        });

        emitter.on('deleteService', (service_id) => {
            this.deleteService(service_id);
        });

        emitter.on("processItemMove", (event) => {
            this.processItemMove(event);
        });

        emitter.on('updateBatchItems', (data) => {
            this.updateBatchItems(data);
        })

        emitter.on('approveService', (data) => {
           this.approveService(data);
        });

        emitter.on('unapproveService', (data) => {
            this.unapproveService(data);
        });
    },
    methods: {
        number_format(nStr) {
            nStr += '';
            let x = nStr.split('.');
            let x1 = x[0];
            let x2 = x.length > 1 ? '.' + x[1] : '';
            let rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2');
            }
            return x1 + x2;
        },
        doRounding(value, decimals) {
            return Number(Math.round(value + "e" + decimals) + "e-" + decimals).toFixed(2);
        },
        editQuote(quote) {
            this.$refs.create_quote.updating = true;
            this.$refs.create_quote.form.id = quote.id;
            this.$refs.create_quote.form.name = quote.name;
            this.$refs.create_quote.form.client = quote.client.name;
            this.$refs.create_quote.form.client_id = quote.client_id;
            this.$refs.create_quote.form.status = quote.status;
            this.$refs.create_quote.form.project_id = quote.project_id;
            this.$refs.create_quote.open();
        },
        processItemMove(event) {

            // ID of the moved item.
            var item_id = event.item.dataset.id;
            var item_type = event.item.dataset.type;

            // ID of the new parent ul folder.
            var parent_id = event.to.parentElement.dataset.id ?? null
            var parent_type = event.to.parentElement.dataset.type ?? null

            // Get the list the item has been moved to.
            let list = [];

            for (let i = 0; i < event.to.children.length + 1; i++) {
                if (typeof event.to.children[i] !== "undefined") {
                    list.push({
                        type: event.item.dataset.id === event.to.children[i].dataset.id ? event.item.dataset.type : event.to.children[i].dataset.type,
                        id: event.to.children[i].dataset.id,
                        order: i
                    });
                }
            }

            // Post request.
            this.$inertia.post(route('frontend.project.quote.move', [this.project.id, this.quote.id]), {
                item_id: item_id,
                item_type: item_type,
                parent_id: parent_id,
                parent_type: parent_type,
                list: list
            }, {
                preserveScroll: true,
                preserveState: true
            });
        },
        deleteFolder(folder_id) {
            this.$swal.fire({
                title: 'Remove Folder',
                html: "Are you sure you wish to delete this folder and any service lines contained within it? <br/><br/> Once removed you will not be able to restore this folder. <br/>",
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                stopKeydownPropagation: true,
                keydownListenerCapture: true
            })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.$inertia.delete(route('frontend.project.quote.folder.delete', [this.project.id, this.quote.id, folder_id]), {
                            preserveScroll: true,
                            onSuccess: (page) => {

                            },
                            onError: (page) => {
                                this.loading = false
                                this.showErrors = true
                            }
                        });
                    }
                });
        },
        deleteService(service_id) {
            this.$swal.fire({
                title: 'Remove Service',
                html: "You are about to delete this service line from the quote, once removed you will be unable to restore this service line.<br/><br/>" +
                    "Are you sure you wish to do this?",
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                stopKeydownPropagation: true,
                keydownListenerCapture: true
            })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.$inertia.delete(route('frontend.project.quote.service.delete', [this.project.id, this.quote.id, service_id]), {
                            preserveScroll: true,
                            onSuccess: (page) => {

                            },
                            onError: (page) => {
                                this.loading = false
                                this.showErrors = true
                            }
                        });
                    }
                });
        },
        cancelQuote(service_id) {
            this.$swal.fire({
                title: 'Confirm Cancellation',
                text: "You are cancelling a quote. Are you sure you'd like to do this?",
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                stopKeydownPropagation: true,
                keydownListenerCapture: true
            })
            .then((result) => {
                if (result.isConfirmed) {
                    this.$inertia.post(route('frontend.project.quote.service.cancel', [this.project.id, this.quote.id, service_id]), {}, {
                        preserveScroll: true,
                        preserveState: true
                    });
                }
            });
        },
        confirmQuote(id) {
            this.emitter.emit("openConfirmQuoteSlideout")
        },
        updateBatchItems(data) {

            // Check if the item already exists in the batchItems array.
            if(data.isChecked === false) {
                this.batchItems.splice(this.batchItems.indexOf(data.item),1);
                return true;
            }

            this.batchItems.push(data.item);
        },
        approveService(service_id) {
            this.$inertia.post(route('frontend.project.quote.service.approve', [this.project.id, this.quote.id, service_id]), {}, {
                preserveScroll: true,
                preserveState: true
            });
        },
        unapproveService(service_id) {
            this.$inertia.post(route('frontend.project.quote.service.unapprove', [this.project.id, this.quote.id, service_id]), {}, {
                preserveScroll: true,
                preserveState: true
            });
        }
    }
}
</script>
